import { useState } from "react";
import { Flex, OverlayStyle, SlideoutDrawerV2, Tab, Tabs, Text } from "@jsq/ds/core";
import { AssignedUsersTab } from "./components/AssignedUsersTab";
import { PermissionsTab } from "./components/PermissionsTab";
import { WorkspaceRoleGroupNames } from "./components/PermissionsTab/consts";
import * as styles from "./styles_vanilla.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  roleName?: WorkspaceRoleGroupNames;
};

enum TabType {
  Permissions = "Permissions",
  AssignedUsers = "Assigned users",
}

const WorkspaceRoleDetails = ({ isOpen, onClose, title, roleName }: Props) => {
  const [activeTab, setActiveTab] = useState<TabType>(TabType.Permissions);

  return (
    <SlideoutDrawerV2
      isOpen={isOpen}
      onClose={onClose}
      isDismissable
      overlayStyle={OverlayStyle.Transparent}
    >
      <SlideoutDrawerV2.ComplexHeader
        title={title}
        subtitles={[
          <Text key="subtitle" variant="secondary-md" asSpan>
            Workspace role
          </Text>,
        ]}
        className={styles.slideoutHeader}
      />
      <SlideoutDrawerV2.Body className={styles.drawerBody}>
        <Flex flexDirection="column" className={styles.container}>
          <Tabs key="tabs" className={styles.tabs}>
            <Tab
              active={activeTab === TabType.Permissions}
              text="Permissions"
              onClick={() => setActiveTab(TabType.Permissions)}
            />
            <Tab
              active={activeTab === TabType.AssignedUsers}
              text="Assigned users"
              onClick={() => setActiveTab(TabType.AssignedUsers)}
            />
          </Tabs>
          <div className={styles.tabContent}>
            {activeTab === TabType.Permissions && <PermissionsTab roleName={roleName} />}
            {activeTab === TabType.AssignedUsers && <AssignedUsersTab roleName={roleName} />}
          </div>
        </Flex>
      </SlideoutDrawerV2.Body>
    </SlideoutDrawerV2>
  );
};

export default WorkspaceRoleDetails;
